export default function renderAdrTaFooterV3(data) {
  return function (pdf) {};
}
